document.addEventListener("DOMContentLoaded", function() {
  // 1. Config: Locate article content and TOC elements
  var articleBody = document.querySelector('.article-template__content') || document.querySelector('.rte');
  var tocContainer = document.getElementById('toc-container');
  var tocTitle = document.querySelector('.toc-title');
  var tocList = document.querySelector('.toc-list');

  if (!articleBody || !tocContainer || !tocList) return;

  // 2. Find all H2 and H3 tags
  var headers = articleBody.querySelectorAll('h2, h3');

  if (headers.length < 2) {
    tocContainer.style.display = 'none';
    return;
  }

  // 3. Generate List Items
  headers.forEach(function(header, index) {
    var anchorId = header.id;
    if (!anchorId) {
      anchorId = 'toc-' + index;
      header.id = anchorId;
    }

    var li = document.createElement('li');
    var link = document.createElement('a');
    
    link.href = '#' + anchorId;
    link.textContent = header.textContent;
    
    if (header.tagName.toLowerCase() === 'h3') {
      li.classList.add('toc-level-3');
    } else {
      li.classList.add('toc-level-2');
    }

    // Auto-close logic on Mobile
    link.addEventListener('click', function() {
      if (window.innerWidth <= 1000) {
        tocContainer.classList.remove('is-open');
      }
    });

    li.appendChild(link);
    tocList.appendChild(li);
  });

  // 4. Show the TOC container
  tocContainer.style.display = 'block';

  // 5. Mobile Toggle Logic
  if (tocTitle) {
    tocTitle.addEventListener('click', function() {
      if (window.innerWidth <= 1000) {
        tocContainer.classList.toggle('is-open');
      }
    });
  }

  // =========================================
  // 6. PC "Show All / Hide" Toggle Logic (Updated)
  // =========================================
  if (headers.length > 5) {
    // 初始状态：折叠
    tocList.classList.add('is-collapsed');

    // 创建按钮
    var showAllBtn = document.createElement('button');
    showAllBtn.className = 'toc-show-all-btn';
    showAllBtn.textContent = 'Show all table of contents'; // 初始文案
    showAllBtn.style.display = 'block'; // 强制显示

    tocContainer.appendChild(showAllBtn);

    // 点击事件：切换状态
    showAllBtn.addEventListener('click', function() {
      
      // 检查当前是否是折叠状态
      if (tocList.classList.contains('is-collapsed')) {
        // [动作：展开]
        tocList.classList.remove('is-collapsed');
        this.textContent = 'Hide table of contents'; // 切换文案
      } else {
        // [动作：收起]
        tocList.classList.add('is-collapsed');
        this.textContent = 'Show all table of contents'; // 恢复文案
        
        // 可选：收起时如果页面很长，可以稍微自动回滚一点点，体验更好，不加也不影响
      }

    });
  }

  /* =========================================
     FAQ Accordion Logic
     ========================================= */
  var faqQuestions = document.querySelectorAll('.faq-question');

  if (faqQuestions.length > 0) {
    faqQuestions.forEach(function(question) {
      question.addEventListener('click', function() {
        var item = this.parentElement;
        var answer = item.querySelector('.faq-answer');

        item.classList.toggle('active');

        if (item.classList.contains('active')) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
          answer.style.maxHeight = null;
        }
      });
    });
  }
});


/* =========================================
     11. Auto-Convert External Links to Bookmarks
     ========================================= */
  
  // 1. 找到文章正文容器
  var contentContainer = document.querySelector('.article-template__content') || document.querySelector('.rte');
  
  if (contentContainer) {
    // 2. 找到所有链接
    var allLinks = contentContainer.querySelectorAll('a');
    var currentHost = window.location.hostname; // 获取当前网站域名

    allLinks.forEach(function(link) {
      // 排除掉我们要保留样式的特殊按钮 (如 CTA, 产品卡按钮)
      if (link.classList.contains('cta-button') || 
          link.classList.contains('card-add-btn') || 
          link.classList.contains('card-details-link')) {
        return;
      }

      // 3. 判断逻辑：必须是外链 且 不包含图片
      if (link.hostname && link.hostname !== currentHost && !link.querySelector('img')) {
        
        // 4. 关键判断：是否是“独立一行”的链接？
        // 逻辑：如果它的父级是 P 标签，且该 P 标签里只有这个链接，没有其他文字
        var parent = link.parentElement;
        var isStandalone = false;

        if (parent.tagName === 'P') {
          // 获取父级纯文本，去除空格
          var parentText = parent.textContent.trim();
          var linkText = link.textContent.trim();
          
          // 如果父级文本 等于 链接文本，说明这一行只有链接
          if (parentText === linkText) {
            isStandalone = true;
          }
        }

        // 5. 如果是独立外链，执行“变身”
        if (isStandalone) {
          // 获取 Favicon (利用 Google 服务)
          var faviconUrl = 'https://www.google.com/s2/favicons?domain=' + link.hostname + '&sz=64';
          
          // 创建卡片结构
          link.classList.add('external-bookmark-card');
          // 强制新窗口打开
          link.target = "_blank";
          
          // 重写内部 HTML
          link.innerHTML = `
            <img src="${faviconUrl}" class="bookmark-icon" alt="${link.hostname}" loading="lazy">
            <div class="bookmark-info">
              <span class="bookmark-title">${link.textContent}</span>
              <span class="bookmark-domain">${link.hostname}</span>
            </div>
          `;
        }
        // 如果不是独立行（在句子中间），保持默认样式，不做处理
      }
    });
  }

  